export interface IQuota {
    from: number;
    to: number;
}

const areIntevalsOvelapped = (q1: IQuota, q2: IQuota): boolean => {
    return q1.to >= q2.from && q2.to >= q1.from;
};

export const isQuotaValid = (q: IQuota): boolean => {
    return q.from <= q.to;
};

export const areQuotasExclusive = (quotas: IQuota[], quota: IQuota): boolean => {
    return quotas.every(q => !areIntevalsOvelapped(q, quota));
};
